/** @format */

export const FacebookSmall = ({color}) => {
    return (
        <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_64_101)">
                <path
                    d="M14.6673 8.00004C14.6673 4.31814 11.6826 1.33337 8.00065 1.33337C4.31875 1.33337 1.33398 4.31814 1.33398 8.00004C1.33398 11.3275 3.77187 14.0856 6.95898 14.5857V9.92712H5.26628V8.00004H6.95898V6.53129C6.95898 4.86046 7.9543 3.93754 9.47708 3.93754C10.2063 3.93754 10.9694 4.06775 10.9694 4.06775V5.70837H10.1288C9.30065 5.70837 9.04232 6.22231 9.04232 6.75004V8.00004H10.8913L10.5957 9.92712H9.04232V14.5857C12.2294 14.0856 14.6673 11.3275 14.6673 8.00004Z"
                    fill={color}
                />
            </g>
            <defs>
                <clipPath id="clip0_64_101">
                    <rect width="16" height="16" fill={color} />
                </clipPath>
            </defs>
        </svg>
    );
};
